import { useEffect, useState } from 'react';
import { CustomButton } from 'holistic-resources';
import { useDispatch, useSelector } from 'react-redux';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { toggleAppOverlay, resetUISlice, toggleLoadingAppOverlay } from 'reducers/ui/uiSlice';
import { resetCurrentUserSlice } from 'reducers/currentUser/currentUserSlice';
import { resetPaymentFormSlice } from 'reducers/paymentForm/paymentFormSlice';
import { resetSettingsSlice } from 'reducers/settingsSlice';
import { logout } from 'services/ApiService';
import { ROUTES_SELF_SERVICE } from 'shared/constants/selfServiceRoutes';

export default function SSOLoginFail() {
  const [reason, setReason] = useState('');
  const [isIdpSecurityEnabled, setIsIdpSecurityEnabled] = useState('');

  const getParamsFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    return {
      URLReason: params.get('reason'),
      URLIsIdpSecurityEnabled: params.get('isIdpSecurityEnabled'),
    };
  };  

  const { whiteLabelSettings: { secondaryColour } = {} } =
    useWhiteLabelSettings();
  const { componentConfig, loggedOutFromTimeout } = useSelector(
    (state) => state.ui,
  );
  const dispatch = useDispatch();

  const onSignoutHandler = async () => {
    try {
      const tempIdpSecurityEnabled = isIdpSecurityEnabled || componentConfig.idpSecurityEnabled;
      dispatch(toggleAppOverlay(false));
      dispatch(resetUISlice());
      dispatch(resetCurrentUserSlice());
      dispatch(resetPaymentFormSlice());
      dispatch(resetSettingsSlice());
      await logout(tempIdpSecurityEnabled);
      window.location.href = `${ROUTES_SELF_SERVICE.LOGIN}`;
    } catch (error) {
      console.error(error);
    }
  };
  
  useEffect(() => {
    const { URLReason, URLIsIdpSecurityEnabled } = getParamsFromUrl();
    if (URLReason) {
      setReason(URLReason);
    }
    if (URLIsIdpSecurityEnabled) {
      setIsIdpSecurityEnabled(URLIsIdpSecurityEnabled);
    }
  }, []);

  useEffect(() => {
    if (!loggedOutFromTimeout) {
      dispatch(toggleLoadingAppOverlay(false));
    }
  }, [loggedOutFromTimeout, dispatch]);

  return (
    <div className="page-not-exists">
      <div>
        <p>Sorry, your login was unsuccessful</p>
      </div>
      <div className="reason">
        {reason && 
          <p>Reason: {reason}</p>
        }
      </div>
          <CustomButton onClick={onSignoutHandler}>
            <div
              style={{ backgroundColor: secondaryColour }}
              className="p-2 text-white rounded-full"
            >
              <div className="font-medium">Return to login page</div>
            </div>
          </CustomButton>
    </div>
  );
}
